import { render, staticRenderFns } from "./CheckboxSwitch.vue?vue&type=template&id=64b6c8a2&scoped=true&"
import script from "./CheckboxSwitch.vue?vue&type=script&lang=js&"
export * from "./CheckboxSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxSwitch.vue?vue&type=style&index=0&id=64b6c8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6c8a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b6c8a2')) {
      api.createRecord('64b6c8a2', component.options)
    } else {
      api.reload('64b6c8a2', component.options)
    }
    module.hot.accept("./CheckboxSwitch.vue?vue&type=template&id=64b6c8a2&scoped=true&", function () {
      api.rerender('64b6c8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/CheckboxSwitch.vue"
export default component.exports